import ArrowCircleRight from '@assets/icons/arrow-circle-right.svg'
import { Icon } from './Icon'

export const ArrowCircleRightIcon = Icon(ArrowCircleRight)
